// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import MembersFullList from "./pages/MembersFullList/MembersFullList";
import IPCensus from "./pages/IPCensus/IPCensus";
import IPCensusManagement from "./pages/IPCensusManagement/IPCensusManagement";
import Profile from "./pages/Profile/Profile";
import DiagnosisCodes from "./pages/DiagnosisCodes/DiagnosisCodes";
import Claims from "./pages/Claims/Claims";
import Opportunities from "./pages/Opportunities/Opportunities";
import LoginPage from "./pages/LoginPage/LoginPage";
import AuthProvider from "./routing/AuthProvider";
import PrivateRoute from "./routing/PrivateRoute";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<PrivateRoute />}>
            <Route element={<AppLayout />}>
              <Route index element={<IPCensusManagement />} />
              <Route path="members/ip-census" element={<IPCensus />} />
              <Route path="members/full-list" element={<MembersFullList />} />
              <Route path="members/face-sheet/profile" element={<Profile />} />
              <Route
                path="members/face-sheet/diagnosis-codes"
                element={<DiagnosisCodes />}
              />
              <Route
                path="ip-census-management"
                element={<IPCensusManagement />}
              />
              <Route path="members/face-sheet/claims" element={<Claims />} />
              <Route
                path="members/face-sheet/opportunities"
                element={<Opportunities />}
              />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
